import { RowNode } from 'ag-grid-community';
import { AgGridColumn } from 'ag-grid-react/lib/agGridColumn';
import React, { useState } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ConnectedHcpGridWithGQL, LocationSearch, ResourceContent } from '.';
import { useOrganizationAddressInfoQuery } from '../graphql';
import { AnyType } from '../interfaces';
import { AppRootState } from '../redux';
import {
  featureGridColumnsSelector,
  generalColumnDefinition,
  getConfigurationDataKey,
  getFeatureGridColumnProps,
  isEmptyObject,
  rawHtmlProps
} from '../utils';
import { FeatureGuard } from './multi-tenant/FeatureGuard';
import { AddLocationView } from '../views';

const columnSelector = featureGridColumnsSelector(getConfigurationDataKey('locations.table'));

export const LocationsTable = ({ searchValue }: { searchValue: string | undefined }) => {
  const verbiageText = useSelector(
    (state: AppRootState) =>
      (((state.app?.entities?.features as AnyType) ?? {})['account-administration-verbiage'] as AnyType)?.data || {}
  );

  const filterLocations = (node: RowNode, value: string | undefined) => {
    const { address1, city, state } = node.data;
    return (
      address1?.toLowerCase().includes(value ?? '') ||
      city?.toLowerCase().includes(value ?? '') ||
      state?.toLowerCase().includes(value ?? '')
    );
  };

  const columns = useSelector(columnSelector);
  if (!columns) return null;

  return (
    <>
      <ConnectedHcpGridWithGQL
        queryHook={useOrganizationAddressInfoQuery}
        isFilterActive={!!searchValue}
        filterComparator={filterLocations}
        filterValue={searchValue}
        pagination>
        <AgGridColumn
          {...generalColumnDefinition()}
          resizable={true}
          field='address1'
          {...getFeatureGridColumnProps(columns.address)}
        />
        <AgGridColumn
          {...generalColumnDefinition()}
          resizable={true}
          field='city'
          {...getFeatureGridColumnProps(columns.city)}
        />
        <AgGridColumn
          {...generalColumnDefinition()}
          resizable={true}
          field='state'
          {...getFeatureGridColumnProps(columns.state)}
        />
        <AgGridColumn
          {...generalColumnDefinition()}
          resizable={true}
          field='zip'
          {...getFeatureGridColumnProps(columns.zip)}
        />
        <AgGridColumn
          {...generalColumnDefinition()}
          resizable={true}
          field='phone1'
          {...getFeatureGridColumnProps(columns.phone)}
        />
      </ConnectedHcpGridWithGQL>

      {!isEmptyObject(verbiageText) && (
        <span className='text-primary ag-theme-alpine' {...rawHtmlProps(verbiageText)} />
      )}
    </>
  );
};
